import { CodeEditorLoadData } from "../types/code-editor-load-data.interface";
import { validateEmpty } from "./validation.util";

export const generateCodeTemplate = (loadData: CodeEditorLoadData) => {
  const {
    shortName,
    longName,
    description,
    initializationValue,
    format,
    codeType,
    defaultValue,
  } = loadData;
  let template = `-- ${shortName}:${longName} \n`;
  description.split('\n').forEach((row) => {
    template += row.includes('\n') ? `-- ${row}` : `-- ${row} \n`;
  });
  template += `-- Date/Time : ${new Date()} \n`;
  if (!validateEmpty(initializationValue)) {
    template += `-- Initialization of ${codeType} \n`;
    template +=
      format === 'Alphanumeric'
        ? `${shortName} = '${initializationValue}' \n`
        : `${shortName} = ${initializationValue} \n`;
  }
  template += `-- Start ${codeType} Code Here ... \n\n\n\n`;
  if (!validateEmpty(defaultValue)) {
    template += `-- Default Value of ${codeType} ... \n`
    template +=
      format === 'Alphanumeric'
        ? `if <condition> then ${shortName} = '${defaultValue}' end`
        : `if <condition> then ${shortName} = ${defaultValue} end`;
  }
  return template;
};